import { useState } from "react";
import { Share2, Facebook, Link2, Check, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function ShareButtons({ productName }) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const text = `${productName} – JINSU | puhtaampaa vettä ihollesi ja hiuksillesi`;

  const shareNative = async () => {
    try {
      await navigator.share({ title: productName, text, url });
    } catch {
      /* user dismissed */
    }
  };

  const copyLink = async () => {
    let ok = false;
    try {
      await navigator.clipboard.writeText(url);
      ok = true;
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        ok = document.execCommand("copy");
        document.body.removeChild(ta);
      } catch {
        ok = false;
      }
    }
    if (ok) {
      setCopied(true);
      toast.success("Linkki kopioitu");
      setTimeout(() => setCopied(false), 2000);
    } else {
      toast.error("Kopiointi epäonnistui – kopioi osoite selaimen osoiterivistä");
    }
  };

  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`;
  const canNativeShare = typeof navigator !== "undefined" && Boolean(navigator.share);

  const btnClass =
    "flex h-11 w-11 items-center justify-center rounded-full bg-secondary text-secondary-foreground transition-all duration-200 hover:bg-primary hover:text-primary-foreground";

  return (
    <div className="mt-9 flex items-center gap-3" data-testid="share-buttons">
      <span className="text-xs font-bold uppercase tracking-widest text-muted-foreground">Jaa tuote</span>
      {canNativeShare && (
        <button onClick={shareNative} className={btnClass} aria-label="Jaa" data-testid="share-native-button">
          <Share2 size={17} />
        </button>
      )}
      <a
        href={facebookUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={btnClass}
        aria-label="Jaa Facebookissa"
        data-testid="share-facebook-button"
      >
        <Facebook size={17} />
      </a>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={btnClass}
        aria-label="Jaa WhatsAppissa"
        data-testid="share-whatsapp-button"
      >
        <MessageCircle size={17} />
      </a>
      <button onClick={copyLink} className={btnClass} aria-label="Kopioi linkki" data-testid="share-copy-button">
        {copied ? <Check size={17} /> : <Link2 size={17} />}
      </button>
    </div>
  );
}
